import apiCall from "./apiCall";

const getDataAgent = async () => {
    const URL = '/Agent/GetDataAgents';
    return apiCall('get', URL);
};

const putDataAgent = async (data: any) => {
    const URL = '/Agent/Update';
    return apiCall('post', URL, data);
};

const postDataAgent = async (data: any) => {
    const URL = '/Agent/Create';
    return apiCall('post', URL, data);
};

export {
    getDataAgent,
    putDataAgent,
    postDataAgent
};
